// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"2":"lang-fr-ts","64":"lang-zh-ts","305":"lang-de-ts","566":"lang-th-ts","597":"lang-no-ts","775":"lang-sv-ts","826":"lang-tt-ts","902":"lang-es-ts"}[chunkId] + "." + {"2":"32f5dba1","64":"ca9592c7","305":"54f065e4","566":"57dcc514","597":"302cbc12","775":"78253c53","826":"9fd73b6e","902":"b33d8577"}[chunkId] + ".js";
};